import React from 'react';

const TrashIcon = props => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M11.25 3H15V4.5H13.5V14.25C13.5 14.6642 13.1642 15 12.75 15H2.25C1.83579 15 1.5 14.6642 1.5 14.25V4.5H0V3H3.75V0.75C3.75 0.33579 4.08579 0 4.5 0H10.5C10.9142 0 11.25 0.33579 11.25 0.75V3ZM12 4.5H3V13.5H12V4.5ZM5.25 6.75H6.75V11.25H5.25V6.75ZM8.25 6.75H9.75V11.25H8.25V6.75ZM5.25 1.5V3H9.75V1.5H5.25Z'
      fill='#F44A3E'
    />
  </svg>
);

export default TrashIcon;
